import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

type Props = {
  /** When the data behind the page was last refreshed. */
  lastRefreshedAt?: string | null;
  /** Refresh-cadence explanation appended to the exact timestamp on hover. */
  hoverText: string;
};

/** Subtle data-freshness note for a dashboard header, e.g. "Last updated 3 hours ago". */
export function DashboardLastUpdated({ lastRefreshedAt, hoverText }: Props) {
  if (!lastRefreshedAt) return null;
  const refreshedAt = parseISO(lastRefreshedAt);
  return (
    <Text
      variant="subtle"
      includeHover
      hoverText={`Updated ${format(refreshedAt, 'd MMM yyyy, HH:mm')}. ${hoverText}`}
      className="whitespace-nowrap text-xs text-gray-500"
    >
      <span className="flex items-center gap-1">
        <Icons.clock className="size-3" />
        Last updated{' '}
        {formatDistanceToNowStrict(refreshedAt, { addSuffix: true })}
      </span>
    </Text>
  );
}
